import helpers from "helpers/index";
import axios from "axios";
import {TypedEvent} from "entities/calendar/calendar.interface";

export async function getListEvent(object: any) {
  const EndURL = helpers.buildEndUrl(object);
  const requestUrl = `event/list${EndURL}`;
  return await axios.get<TypedEvent[]>(requestUrl);
}
